module.exports = __webpack_public_path__ + "static/media/golden_rule_book.e4b5a6b3.webp";